import type StyleTypesUtil from "./styleTypesUtil";

const es = global.es; // TODO: Remove dependency!

export default class SymbolAndPolygonStyleTypeUtil {
    private styleTypesUtil: StyleTypesUtil;

    constructor(styleTypesUtil: StyleTypesUtil) {
        this.styleTypesUtil = styleTypesUtil;
    }

    /**
     * 
     * @param style 
     * @param geom 
     * @param point 
     * @param resolution 
     * 
     * @returns 
     */
    containsPoint(style, geom, point, resolution): boolean {
        if (geom[0] === "MG") {
            return this.styleTypesUtil[style.symbolStyle.$type].containsPoint(style.symbolStyle, geom[1], point, resolution);
        }
        
        if (this.styleTypesUtil[style.polygonStyle.$type].containsPoint(style.polygonStyle, geom, point, resolution)) {
            return true;
        }

        const pnt = this.getFocalPoint(style, geom);
        pnt.splice(0, 0, "PT");
        return this.styleTypesUtil[style.symbolStyle.$type].containsPoint(style.symbolStyle, pnt, point, resolution);
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    getColor(style) {
        return style.symbolStyle.color;
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    mainColor(style) {
        return this.getColor(style);
    }
    
    /**
     * 
     * @param style 
     * @param color 
     * 
     * @returns 
     */
    withColor(style, color) {
        style = es.util.object.deepCopy(style);
        delete style._hash;
        
        const fillAlpha = es.util.color.getAlpha(color) * 0.4; // FILL_ALPHA_RELATION = 0.4;
        const fillColor = es.util.color.withAlpha(color, fillAlpha);
        style.polygonStyle = es.api.style.withColor(style.polygonStyle, fillColor);
        style.polygonStyle.line.color = color;
        style.symbolStyle = es.api.style.withColor(style.symbolStyle, color);
        
        return style;
    }
    
    /**
     * 
     * @param style 
     * @param symbolTypeId 
     * 
     * @returns 
     */
    withSymbol(style, symbolTypeId) {
        style = es.util.object.deepCopy(style);
        delete style._hash;
        
        style.symbolStyle = es.api.style.withSymbol(style.symbolStyle, symbolTypeId);
        
        return style;
    }
    
    /**
     * 
     * @param style 
     * @param size 
     * 
     * @returns 
     */
    withSymbolSize(style, size) {
        style = es.util.object.deepCopy(style);
        delete style._hash;
        
        style.symbolStyle = this.styleTypesUtil[style.symbolStyle.$type].withSymbolSize(style.symbolStyle, size);
        
        return style;
    }

    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    getPaddingPx(style): number[] {
        let max;
        if (style.symbolStyle.$type == "SymbolStyle") {
            max = style.symbolStyle.size;
        } else { // style.symbolStyle.$type == "SymbolAndPolygonStyle"
            max = style.symbolStyle.symbol.size;
            
        }
        max = Math.max(max, style.polygonStyle.line ? style.polygonStyle.line.width : 0);
        
        return [max, max];
    }
    
    /**
     * 
     * @param style 
     * @param geom 
     * @param pnt 
     * 
     * @returns 
     */
    getFocalPoint(style, geom, pnt) {
        if (geom) {
            const bounds = this.getFocalBounds(style, geom);
            pnt = [(bounds[0] + bounds[2]) / 2, (bounds[1] + bounds[3]) / 2];
        }

        return pnt;
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    getText(style) {
        return style.symbolStyle.text; // want parent text type and not child
    }
    
    /**
     * 
     * @param style 
     * @param geom 
     * 
     * @returns 
     */
    getFocalBounds(style, geom: any[]): any[] {
        switch(geom[0]) {
            case "MP":
                let bounds;
                let area = -1;
                for (let g = geom.length; g-- > 1;) {
                    const b = es.util.bounds.valueOf(geom[g][0]);
                    const a = es.util.bounds.area(b);
                    if(a > area){
                        area = a;
                        bounds = b;
                    }
                }
                return bounds;

            case "MG":
                for (let g = geom.length; g-- > 1; ) {
                    const part = geom[g];
                    if (part[0] === "PT") {
                        return this.styleTypesUtil.SymbolStyle.getFocalBounds(style, part);
                    }
                }
                //break;//fall through is deliberate!
            default:
                return es.api.geom.getBounds(geom);
        }
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    hasDirect(style): boolean {
        return true;
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    hasOverlays(style): boolean {
        return true;
    }
}
